import Vue from 'vue'
import Router from 'vue-router'


// import metaInfo from './meta.js'
Vue.use(Router)
const router = new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: '',
			component: () => import('../views/download'),
			meta: {
				title: '',
				isLogin: false,
			}
		},{
			path: '/main',
			name: '',
			component: () => import('../views/main'),
			meta: {
				title: '',
				isLogin: false,
			}
		}]
})


export default router
